import React, { useEffect } from 'react';
import { UploadZone } from './UploadZone';
import { FileList } from './FileList';
import { useFileUpload } from '../../hooks/useFileUpload';
interface DocumentUploadProps {
  userId: string;
  category: string;
}
export function DocumentUpload({
  userId,
  category
}: DocumentUploadProps) {
  const {
    uploadFile,
    deleteFile,
    loadUserFiles,
    uploadProgress,
    uploadedFiles
  } = useFileUpload(userId);
  useEffect(() => {
    loadUserFiles(category);
  }, [category]);
  const handleFilesAccepted = async (files: File[]) => {
    for (const file of files) {
      try {
        await uploadFile(file, category);
      } catch (error) {
        console.error(`Failed to upload ${file.name}:`, error);
      }
    }
  };
  const handleDelete = async (file: any) => {
    if (window.confirm(`Are you sure you want to delete ${file.fileName}?`)) {
      try {
        await deleteFile(file);
      } catch (error) {
        console.error('Failed to delete file:', error);
        alert('Failed to delete file. Please try again.');
      }
    }
  };
  return <div className="space-y-4" data-id="element-2120">
            <UploadZone onFilesAccepted={handleFilesAccepted} data-id="element-2121" />
            <FileList files={uploadedFiles} uploadProgress={uploadProgress} onDelete={handleDelete} data-id="element-2122" />
        </div>;
}